import moment from "moment"

  export function sendSuccessNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_UPDATED', notice);
  }
  
  export function sendErrorNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_FAILED', notice);
  }

  export function refreshResource () {
    window.getApp.$emit('REQUEST_REFRESH_DATA');
  }

  export function buildBreadcrumb(routeName, routePath, pId, title, menu, paths) {
    let breadcrumbs = [];
    menu.forEach(item => {
      if (item.name === routeName) {
        breadcrumbs.push({
          text: item.title,
          link: false,
          href: ""
        });
      } else if (item.items) {
        breadcrumbs = _.concat(breadcrumbs, buildBreadcrumb(routeName, routePath, pId, title, item.items, paths))
      } else if (item.children) {
        let child = item.children.find(i => {
          return i.component === routeName;
        });
        if (child) {
          let path = _.find(paths, { name: item.name });
          breadcrumbs.push({
            text: item.title,
            disabled: false,
            href: path ? path.path : ""
          });
          breadcrumbs.push({
            text: title || `${child.title} (#${pId})`,
            link: false,
            href: ""
          });
        }
      }
    });
    return breadcrumbs;
  }

  export function getCurrentTime() {
    var d = new Date();
    d.setTime( d.getTime());
    return moment(d);
  }

  export function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

  export function playSound (sound) {
    if(sound) {
      var audio = new Audio(sound);
      audio.play();
    }
  }

  export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

export function proxyImage(imageUrl) {
    if (!imageUrl) {
        return ''
    };
    
    // Nếu ảnh đã là từ domain local thì không cần proxy
    if (process.env.NODE_ENV === "development" || imageUrl.startsWith('/') || imageUrl.includes(window.location.hostname) || imageUrl.includes('firebase') || imageUrl.includes('r2') || !imageUrl.includes('alicdn.com')) {
        return imageUrl;
    }
    
    return `https://image-proxy.mamdtech.com/oee-images/${imageUrl.replace(/https?:\/\//, '')}`;
}

export function parseImageList(rawValue) {
  if (!rawValue) {
    return [];
  }

  if (Array.isArray(rawValue)) {
    return rawValue.filter(Boolean);
  }

  if (typeof rawValue === "string") {
    const trimmed = rawValue.trim();
    if (!trimmed) {
      return [];
    }

    if ((trimmed.startsWith("[") && trimmed.endsWith("]")) || (trimmed.startsWith("{") && trimmed.endsWith("}"))) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.filter(Boolean);
        }
      } catch (e) {
        // Keep fallback parsing below.
      }
    }

    return trimmed
      .split(/[\n;,]/)
      .map(item => item.trim())
      .filter(Boolean);
  }

  return [];
}

export function getFirstImage(rawValue) {
  const images = parseImageList(rawValue);
  return images.length > 0 ? images[0] : "";
}

let activeConfirmHandler = null;

export function confirmAction(action, id, message) {
  return new Promise((resolve) => {
    const app = window.getApp;
    if (!app) {
      resolve(false);
      return;
    }
    
    const root = app.$root;
    
    if (activeConfirmHandler) {
      root.$off("CONFIRMED_ACTION", activeConfirmHandler);
    }
    
    activeConfirmHandler = ({ action: confirmedAction, id: confirmedId }) => {
      if (confirmedAction === action && confirmedId === id) {
        root.$off("CONFIRMED_ACTION", activeConfirmHandler);
        activeConfirmHandler = null;
        resolve(true);
      }
    };
    
    root.$on("CONFIRMED_ACTION", activeConfirmHandler);
    app.$emit("REQUEST_CONFIRM_ACTION", action, id, message);
  });
}
